import session from './session';

export default {
  login(username, password) {
    return session.post('/api/v1/user/login/', { username, password });
  },
  changeAccountPassword(password, password1, password2) {
    return session.post('/api/v1/user/change-password/', { password, password1, password2 });
  },
  resetAccountPassword(contact_phone) { // eslint-disable-line camelcase
    return session.post('/api/v1/user/password_reset/', { contact_phone });
  },
};
